import React, { useCallback } from 'react'
import { api } from '../requests/axios'
import { Box, Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import ColorChartWithNumbers from 'components/ColorChartWithNumbers'
import IntarsiaCanvas from '../components/IntarsiaCanvas'
import { useParams } from 'react-router-dom'

interface ColorChart {
  id: number;
  name: string;
  description: string | null;
  data: string;
  height: number;
  width: number;
  craft?: string;
  crochet_stitch_type?: string;
}

export default function ShowColorChart() {
  const [colorChartData, setColorChartData] = useState<ColorChart>({id: 0, name: '', description: null, data: '{}', height: 0, width: 0, craft: undefined, crochet_stitch_type: undefined})
  const [isEditMode, setIsEditMode] = useState(false)
  const { id } = useParams<{ id: string }>()

  const setData = useCallback(async () => {
    const response = await api.get(`${process.env.REACT_APP_API_PROXY_URL || ''}/color_charts/${id}.json`)
    const data = await response.data
    console.log(data)
    setColorChartData(data)
  }, [id])

  useEffect(() => {
    setData()
  }, [setData])

  const handleSave = useCallback(async () => {
    await setData()
    setIsEditMode(false)
  }, [setData])

  const handleEditClick = useCallback(() => {
    setIsEditMode(true)
  }, [])

  if (isEditMode) {
    return (
      <IntarsiaCanvas
        chartId={colorChartData.id}
        initialData={colorChartData.data}
        initialName={colorChartData.name}
        initialDescription={colorChartData.description}
        initialWidth={colorChartData.width}
        initialHeight={colorChartData.height}
        initialCraft={colorChartData.craft as 'knitting' | 'crochet' | 'cross_stitch' | undefined}
        initialCrochetStitchType={colorChartData.crochet_stitch_type as 'sc' | 'hdc' | 'dc' | undefined}
        onSave={handleSave}
      />
    )
  }

  return (
    <Box>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 600 }}>
            {colorChartData.name || 'Untitled Color Chart'}
          </Typography>
          {colorChartData.description && (
            <Typography variant="body1" color="text.secondary">
              {colorChartData.description}
            </Typography>
          )}
        </Box>
        <Button 
          variant="contained" 
          onClick={handleEditClick}
          sx={{ ml: 2 }}
        >
          Edit
        </Button>
      </Box>
      <ColorChartWithNumbers color_chart={colorChartData} />
    </Box>
  )
}
